// 兼容 IE
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md#babelpolyfill
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局引入
import Vant from 'vant';
import { WeixinShare } from './utils/wx'

// 引入全局样式

import '@/assets/css/global.css'
import '@/assets/css/index.scss'
// 移动端适配
import 'lib-flexible/flexible.js'
import 'amfe-flexible'

import '@vant/touch-emulator'

// filters
// import './filters'

import 'vant/lib/index.css';
import { Lazyload } from 'vant';

export const app = createApp(App);
app.use(router)
app.use(store)
app.use(Vant)
app.use(Lazyload, {
  lazyComponent: true,
})
app.use(WeixinShare)

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()

// 调试顺畅
if (process.env.NODE_ENV === 'development') {
  if ('__VUE_DEVTOOLS_GLOBAL_HOOK__' in window) {
    // 这里__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue赋值一个createApp实例
    // window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app
  }
  app.config.devtools = true
}



app.mount('#app')
